<script setup lang="ts">
import { defineEmits } from "vue";
const action = (index: number) => {
  emit("menuAction", index);
};

const emit = defineEmits(["menuAction"]);
</script>

<template>
  <div class="menu-base">
    <div></div>

    <el-tooltip v-if="false" effect="dark" content="编辑" placement="top">
      <el-icon :color="`#888888`" @click="action(1)" class="icon" :size="20"
        ><Edit
      /></el-icon>
    </el-tooltip>
    <el-tooltip effect="dark" content="复制" placement="top">
      <el-icon :color="`#888888`" @click="action(0)" class="icon" :size="20">
        <CopyDocument />
      </el-icon>
    </el-tooltip>
  </div>
</template>

<style lang="scss" scoped>
.menu-base {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 36px;
  flex-direction: row-reverse;
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    cursor: pointer;
    border-radius: 8px;
    &:hover {
      background-color: #eeeeee;
    }
  }
}
</style>
